<template>
  <div class="content_main padding_row_10">
    <div class="mainTop flex_sb_c" v-if="hourInfo">
      <div class="topUser flex_c_c">
        <div class="userImg">
          <img class="userHead" :src="hourInfo.avatar" />
        </div>
        <div class="userName">{{ hourInfo.userName }}，欢迎回来！</div>
      </div>
      <div class="topTime flex_c_c">
        <div class="enterTime">已加入课表：{{ hourInfo.chosenHours }} 学时</div>
        <div class="allTime">已完成学时：{{ hourInfo.accomplishHours }} 学时</div>
        <div class="allTime">目标总学时：{{ hourInfo.targetHours }} 学时</div>
      </div>
    </div>
    <div class="mainView">
      <a-tabs type="card" @change="callback">
        <a-tab-pane key="1" tab="全部课程">
          <div class="content_main" id="content1">
            <div class="tabCards" id="tabCards">
              <div :class="allIdx == index ? 'cardItemActive cardItem' : 'cardItem'" v-for="(item, index) in allCourse"
                :key="index" @click="changeCourse(index)">
                {{ item.categoryName }}
              </div>
            </div>
            <div class="tabCenter" :style="{ height: tabCenterHeight1 + 'px' }">
              <div class="itemBox" v-for="(item, index) in list" :key="index" v-show="!showActive||item.issueFlag!=2">
                <div class="must" v-if="item.recommend == 1">
                  <img src="../../../assets/image/must.png" alt="" />
                </div>
                <div class="boxImg">
                  <img :src="item.coverUrl" alt="" />
                </div>
                <div class="boxVal">
                  <div class="valTitle">{{ item.courseName }}</div>
                  <div class="valBtns flex_sb_c">
                    <div class="btnLeft">
                      <div class="btn" :style="{'color':item.cssClass,'border':'1px solid' +item.cssClass}">
                        {{ item.categoryName }}
                      </div>
                      <div class="btn" style="border: 1px solid #999; background: #eee">{{ item.classHour }}学时</div>
                    </div>
                    <div class="btnStatus2" v-if="item.checked == 0">已加入课表</div>
                    <div class="btnStatus2" v-else-if="item.issueFlag == 2">已下架</div>
                    <div class="btnStatus" v-else @click="addMyExam(index)">加入课表</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="我的课表">
          <div class="content_main" id="content2">
            <div class="tabCards" id="tabCards2">
              <div :class="myIdx == index ? 'cardItemActive cardItem' : 'cardItem'" v-for="(item, index) in myCourse"
                :key="index" @click="changeMyCourse(index)">
                {{ item.categoryName }}
              </div>
            </div>
            <div class="tabCenter" :style="{ height: tabCenterHeight2 + 'px' }">
              <div class="itemBox" v-for="(item, index) in mylis" :key="index"
                v-show="!showActive||item.courseInfo.issueFlag!=2">
                <div class="must" v-if="item.courseInfo.recommend == 1">
                  <img src="../../../assets/image/must.png" alt="" />
                </div>
                <div class="del" title="删除课程" v-if="item.status != 2 || item.joinType!=0" @click="delCourse(index)">
                  <a-icon type="delete" theme="filled" />
                </div>
                <div class="boxImg">
                  <img :src="item.courseInfo.coverUrl" alt="" />
                </div>
                <div class="boxVal">
                  <div class="valTitle">{{ item.courseInfo.courseName }}</div>
                  <div class="valBtns flex_sb_c" style="margin-top: 5px">
                    <div class="btnLeft">
                      <div class="btn"
                        :style="{'color':item.courseInfo.cssClass,'border':'1px solid' +item.courseInfo.cssClass}">
                        {{ item.courseInfo.categoryName }}
                      </div>
                      <div class="btn" style="border: 1px solid #999; background: #eee">
                        {{ item.courseInfo.classHour }}学时
                      </div>
                    </div>
                    <template v-if="item.courseInfo.issueFlag == 2">
                      <div class="btnStatus2">已下架</div>
                    </template>
                    <template v-else>
                      <div class="btnStatus" v-if="item.status == 0" @click="enterVideo(index)">开始学习</div>
                      <div class="btnStatus" v-if="item.status == 1" @click="enterVideo(index)">继续学习</div>
                      <div class="btnStatus2" v-if="item.status == 2" @click="enterVideo(index)">再次学习</div>
                    </template>
                  </div>
                  <div class="schedule">
                    <div class="scheduleBox">
                      <div class="scheduleBoxVal" :style="{ width: item.schedule + '%' }"></div>
                    </div>
                    <div class="scheduleVal">{{ item.schedule }}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="showActive">
        <span style="margin-right:6px">隐藏已下架</span>
        <a-switch v-model="showActive" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  training_lis,
  training_getTypeList,
  training_mylis,
  training_my_del,
  training_addMyExam,
  getMyHours,
} from '@/api/question'
export default {
  data() {
    return {
      allCourse: [{ id: '', categoryName: '全部' }],
      list: [], //全部课程
      allIdx: 0, //全部课程索引
      tabCenterHeight1: 0, //第一个chenter 动态高度
      myCourse: [{ id: '', categoryName: '全部' }],
      myIdx: 0,
      mylis: [], //我的课程
      myCourseId: '',
      tabCenterHeight2: 0, //第二个chenter 动态高度
      hourInfo: null, //个人信息
      showActive: true,
    }
  },
  mounted() {
    this.tabCenterHeight1 = $('#content1').height() - $('#tabCards').height()
    this.init()
  },
  methods: {
    init() {
      this.get_all()
      this.get_my_all()
      this.get_hours()
    },
    //获取全部课程
    get_all() {
      this.allCourse = [{ id: '', categoryName: '全部' }];
      training_getTypeList({ type: 0 }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        res.data.forEach((element) => {
          this.allCourse.push(element)
        })
        this.get_lis()
      })
    },
    //我的课程
    get_my_all() {
      this.myCourse = [{ id: '', categoryName: '全部' }];
      training_getTypeList({ type: 1 }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        res.data.forEach((element) => {
          this.myCourse.push(element)
        })
        this.get_my_lis()
      })
    },
    //获取我的课时
    get_hours() {
      getMyHours().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.hourInfo = res.data
      })
    },
    //改变课程列表
    changeCourse(idx) {
      this.allIdx = idx;
      this.get_lis()
    },
    //改变我的课程类别
    changeMyCourse(idx) {
      this.myIdx = idx
      var id = this.myCourse[idx].id
      this.myCourseId = id
      this.get_my_lis()
    },
    //点击tabs
    callback(e) {
      console.log(e)
      this.$nextTick(() => {
        if (e == 1) {
          this.tabCenterHeight1 = $('#content1').height() - $('#tabCards').height()
        } else {
          this.tabCenterHeight2 = $('#content2').height() - $('#tabCards2').height()
        }
      })
    },
    //获取全部课程列表
    get_lis(id = '') {
      training_lis({ trainId: this.allCourse[this.allIdx].id }).then((res) => {
        // console.log(res)
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.list = res.data.list
      })
    },
    //获取我的课程列表
    get_my_lis() {
      training_mylis({ trainId: this.myCourseId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.mylis = res.data.list
      })
    },
    //删除课程
    delCourse(idx) {
      var _this = this
      var title = this.mylis[idx].courseInfo.courseName
      var content = '确认删除《 ' + title + ' 》课程？'
      this.$confirm({
        title: '提示',
        content: content,
        onOk() {
          training_my_del({ id: _this.mylis[idx].courseId }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.get_all()
            _this.get_my_all()
            _this.get_hours()
            _this.$message.success('删除成功')

          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
    //加入课表
    addMyExam(idx) {
      var _this = this
      var title = this.list[idx].courseName
      var content = '确认将《 ' + title + ' 》加入我的课程？'
      this.$confirm({
        title: '提示',
        content: content,
        onOk() {
          training_addMyExam({ courseId: _this.list[idx].id }).then((res) => {
            if (res.code != 200) {
              return _this.$message.error(res.msg)
            }
            _this.$message.success('加入成功')
            _this.list[idx].checked = 0
            _this.$forceUpdate()
            _this.get_my_all()
            _this.get_hours()
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
    //进入在线学习
    enterVideo(idx) {
      let item = this.mylis[idx]
      this.$router.push({
        name: 'mycourseVideo',
        query: {
          objstr: item,
        },
      })
    },
  },
}
</script>

<style lang='less' scoped>
@import '../../../assets/css/mian.less';
::v-deep .ant-tabs-tabpane {
  height: 100%;
}
.mainTop {
  width: 100%;
  height: 70px;
  float: left;
  padding: 0 25px;
  box-sizing: border-box;
  background: @mColor;
  border-radius: 5px;
  margin-bottom: 15px;
  .topUser {
    .userImg {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #fff;
      overflow: hidden;
      float: left;
      .userHead {
        width: 100%;
        height: 100%;
        float: left;
        object-fit: cover;
      }
    }
    .userName {
      font-size: 18px;
      color: #fff;
      margin-left: 15px;
      float: left;
    }
  }
  .topTime {
    .enterTime {
      font-size: 18px;
      color: #fff;
    }
    .allTime {
      font-size: 18px;
      color: #fff;
      margin-left: 20px;
    }
  }
}
.mainView {
  width: 100%;
  height: calc(100% - 85px);
  float: left;
  position: relative;
  .showActive {
    position: absolute;
    right: 6px;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    height: 40px;
  }
  .tabCards {
    width: 100%;
    float: left;
    padding: 10px 0 0 0;
    box-sizing: border-box;
    .cardItemActive {
      color: #fff !important;
      background: @mColor;
    }
    .cardItem {
      padding: 4px 10px;
      float: left;
      border: 1px solid @mColor;
      color: @mColor;
      border-radius: 3px;
      cursor: pointer;
      transition: 0.3s;
      margin-right: 12px;
      font-size: 14px;
      margin-bottom: 10px;
      &:hover {
        color: #fff;
        background: @mColor;
      }
    }
  }
  .tabCenter {
    width: 100%;
    float: left;
    overflow-y: scroll;
    padding-top: 2px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      width: 8px; //对垂直方向滚动条
      height: 6px; //对水平方向滚动条
    }
    //滚动的滑块
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: #ddd//滚动条的颜色;
    }
    //内层滚动槽
    &::-webkit-scrollbar-track-piece {
      background-color: #eee;
    }
    .itemBox {
      width: calc(100% / 3 - 15px);
      float: left;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0 0 7px rgb(214, 214, 214);
      border-radius: 7px;
      margin-bottom: 22px;
      margin-left: 1px;
      height: 120px;
      margin-right: 21px;
      transition: 0.3s;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0 0 10px @mColorHover;
        .del {
          right: 8px;
        }
      }
      .del {
        position: absolute;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 0 7px #ddd;
        font-size: 18px;
        transition: 0.2s;
        top: 8px;
        right: -100px;
        z-index: 10;
        color: red;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          box-shadow: 0 0 10px #999;
        }
      }
      .must {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 9;
        img {
          width: 100%;
          height: 100%;
          float: left;
        }
      }
      .boxImg {
        width: 30%;
        float: left;
        border-radius: 5px;
        overflow: hidden;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          float: left;
          object-fit: revert;
        }
      }
      .boxVal {
        width: calc(70% - 10px);
        float: right;
        .valTitle {
          width: 100%;
          float: left;
          font-size: 15px;
          font-weight: 600;
          color: #777;
          min-height: 45px;
        }
        .valBtns {
          width: 100%;
          float: left;
          margin-top: 15px;
          .btn {
            padding: 2px 5px;
            float: left;
            font-size: 12px;
            border-radius: 3px;
            margin-right: 5px;
          }
          .btnStatus2 {
            padding: 4px 10px;
            border-radius: 4px;
            float: left;
            cursor: pointer;
            color: #fff;
            font-size: 13px;
            background: #999;
          }
          .btnStatus {
            background: @mColor;
            padding: 4px 10px;
            border-radius: 4px;
            float: left;
            font-size: 13px;
            cursor: pointer;
            color: #fff;
            transition: 0.3s;
            &:hover {
              background: @mColorHover;
            }
          }
        }
        .schedule {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          float: left;
          margin-top: 2px;
          .scheduleBox {
            width: calc(100% - 35px);
            height: 100%;
            float: left;
            height: 3px;
            position: relative;
            background: #eee;
            .scheduleBoxVal {
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              background: @mColor;
            }
          }
          .scheduleVal {
            width: 35px;
            float: left;
            font-size: 12px;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>